function BluPlusConfiguration() {
    this.__type = 'BluPlusConfiguration:www.veritracks.com';
    this.Id = -1;
    this.Version = 0;

    this.EnrolleeId = -1;
    this.TetheredAddressId = -1;
    this.VerificationPeriod = -1;
    this.TransactionId = '';
}
if (typeof exports !== 'undefined') {
    module.exports = BluPlusConfiguration;
}